import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { isChecking, isAuthed } = useAuth();
  const location = useLocation();

  if (isChecking) {
    return (
      <div
        className="h-screen w-screen flex items-center justify-center bg-[#121417] text-[#9CA3AF] text-sm font-mono"
        data-testid="auth-checking"
      >
        Comprobando sesión…
      </div>
    );
  }

  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
